/**
 * Fill the placeholder div for product add to cart with data from WooCommerce
 *
 * @param {string} productId
 * @param {Object} product
 */
export const setAddToCartContent = ( productId, product ) => {
	const isPurchasable = product?.is_purchasable ?? false;
	const addToCartArgs = product?.add_to_cart ?? false;
	const addToCartElement = document.getElementById(
		`ma-js-cart-${ productId }`
	);

	if ( ! addToCartElement ) {
		console.warn( 'Found no add to cart element to include buy button' );
		return;
	}

	if ( addToCartElement.classList.contains( 'ma-buy-fetched' ) ) {
		return;
	}

	if ( addToCartArgs ) {
		const { text, description, classes, quantity } = addToCartArgs;
		let { url } = addToCartArgs;
		if ( quantity.min_value && quantity.min_value > 1 ) {
			url += '&quantity=' + quantity.min_value;
		}
		const linkElement = document.createElement( 'a' );
		linkElement.setAttribute( 'href', url );
		linkElement.setAttribute( 'aria-label', description );
		linkElement.className = classes;
		linkElement.innerHTML = text;

		if ( ! isPurchasable ) {
			linkElement.setAttribute( 'disabled', true );
		}

		linkElement.classList.add( 'ma-buy-fetched' );

		addToCartElement.appendChild( linkElement );
	}

	addToCartElement.classList.remove( 'ma-line-loader' );
};
